import { API_ENDPOINTS, getApiUrl, getAuthHeaders } from '../config/api';

export interface PromoValidationResult {
  valid: boolean;
  code?: string;
  discountType?: 'percentage' | 'flat';
  discountAmount: number;
  finalAmount: number;
  message: string;
}

export const promoApi = {
  /**
   * Preview a promo code against a cart subtotal. Advisory only - the discount is
   * re-validated and consumed server-side at checkout, so this can't be gamed.
   */
  validate: async (
    code: string,
    amount: number,
    eventId?: number | string
  ): Promise<PromoValidationResult> => {
    const response = await fetch(getApiUrl(API_ENDPOINTS.PROMO.VALIDATE), {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        code,
        amount,
        eventId: eventId != null ? Number(eventId) : undefined,
      }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(data.detail || `Could not check promo code (${response.status})`);
    }
    return {
      valid: Boolean(data.valid),
      code: data.code,
      discountType: data.discountType,
      discountAmount: Number(data.discountAmount ?? 0),
      finalAmount: Number(data.finalAmount ?? amount),
      message: data.message ?? '',
    };
  },
};
